import React, { useState /* , useCallback */ } from 'react';
import styles from './index.module.less';
import moment from 'moment';
import {
  Radio,
  Button,
  Row,
  Col,
  Card,
  Empty,
  Tooltip,
  Tag
  // Popconfirm,
  // Space
} from 'antd';
//import plus from '../../images/plus.svg';
import SearchBar from '@/common/Content/searchBar';
import CustomTable from 'common/Content/CustomTable';
import {
  // EditOutlined,
  ArrowLeftOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { history } from 'app/history';
//import LocalStorage from 'utilities/localStorage';
import AllExportReports from '../reports/AllExportReports';

const filters = [
  /*  {
    name: 'Gift Received',
    value: ''
  },
  {
    name: 'Pending',
    value: 'pending'
  },
  {
    name: 'Accepted',
    value: 'accepted'
  },
  {
    name: 'Rejected',
    value: 'rejected'
  } */
];

function BulkUploadFlowPage({
  radiofilter,
  setRadiofilter,
  setTriggerFilter,
  page,
  setPage,
  pageSize,
  setPageSize,
  setSearchRequest,
  adminBulkGiftConfigs,
  adminBulkGiftConfigsLoading,
  pagination
}) {
  // Map bulk gift configs data for table display
  const bulkGiftConfigsList = adminBulkGiftConfigs?.map((item) => {
    return {
      key: item?.id,
      id: item?.id,
      upldFrmDate: item?.upldFrmDate || 'N/A',
      upldToDate: item?.upldToDate || 'N/A',
      fiscalYear: item?.fiscalYear || 'N/A',
      giftsFrmDate: item?.giftsFrmDate || 'N/A',
      giftsToDate: item?.giftsToDate || 'N/A',
      status:
        item?.isActive !== undefined
          ? item?.isActive
          : item?.status !== undefined
          ? item?.status
          : true
    };
  });
  console.log('bulkGiftConfigsList', bulkGiftConfigsList);
  // const handleBU_record = (record) => {
  //   console.log('RRRRRRRRR@@@@@@@@@@', record);
  //   history.push(`edit-roUsers-flow/${record.id}`);
  //   LocalStorage.setItem('roUsers_record', JSON.stringify(record));
  // };

  const [isAllExortModalOpen, setAllExortModalOpen] = useState(false);

  const columns = [
    {
      title: 'Start Date',
      dataIndex: 'giftsFrmDate',
      key: 'giftsFrmDate',
      ellipsis: true,
      sorter: (a, b) => a?.giftsFrmDate?.localeCompare(b?.giftsFrmDate),
      render: (giftsFrmDate) => {
        const formattedDate = giftsFrmDate
          ? moment(giftsFrmDate).format('DD MMM YYYY')
          : 'N/A';
        return (
          <>
            <Tooltip
              title={formattedDate}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {formattedDate}
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'End Date',
      dataIndex: 'giftsToDate',
      key: 'giftsToDate',
      ellipsis: {
        showTitle: false
      },
      sorter: (a, b) => a?.giftsToDate?.localeCompare(b?.giftsToDate),
      render: (giftsToDate) => {
        const formattedDate = giftsToDate
          ? moment(giftsToDate).format('DD MMM YYYY')
          : 'N/A';
        return (
          <>
            <Tooltip
              title={formattedDate}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              <span className={styles.text_transform}>{formattedDate}</span>
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Fiscal Year',
      dataIndex: 'fiscalYear',
      key: 'fiscalYear',
      ellipsis: true,
      sorter: (a, b) => a?.fiscalYear?.localeCompare(b?.fiscalYear),
      render: (fiscalYear) => {
        return (
          <>
            <Tooltip
              title={fiscalYear}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {fiscalYear === null || fiscalYear === '' ? 'N/A' : fiscalYear}
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      //width: '120px',
      ellipsis: true,
      //sorter: (a, b) => a?.status?.localeCompare(b?.status),
      render: (status, record) => (
        <Tag
          className={`${styles.status_style}`}
          color={
            record?.status === true
              ? 'green'
              : record?.status === false
              ? 'red'
              : 'transparent'
          }
        >
          {record?.status === true ? 'ACTIVE' : 'DEACTIVATED'}
        </Tag>
      )
    }
    /*  {
      title: 'Action',
      key: '',
      width: 180,
      render: (record) => (
        <>
          <Space size="middle">
            <>
              <EditOutlined
                className={`${styles.edit_bu}`}
                onClick={() => handleBU_record(record)}
              />
              <Popconfirm
                placement="top"
                title="Are you sure you want to deactivate this RO mapping?"
                visible={visibility(record)}
                onConfirm={() => {
                  handleDeleteRequest({
                    record: record
                  });
                }}
                onCancel={() => {
                  setShowDisablePopup({});
                }}
                okText="Deactivate"
                cancelText="No"
                okButtonProps={{ type: 'danger' }}
              >
                <a
                  className={`${styles.allocation_btn}`}
                  style={{
                    fontSize: '12px'
                  }}
                  type="link"
                  disabled={record?.status === false}
                >
                  Deactivate
                </a>
              </Popconfirm>
            </>
          </Space>
        </>
      )
    } */
  ];

  // const visibility = useCallback((record) => {
  //   return showDisablePopup[record.id];
  // }, showDisablePopup);

  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        <div className={styles.empty_state_text}>
          There are no Bulk Gift Configs to display
        </div>
      </span>
    )
  };

  return (
    <>
      <div className={`${styles.container}`}>
        <Row className={`${styles.row_container}`}>
          <div className={`${styles.gift_container}`}>
            <div className={`${styles.myGift_title}`}>
              Configure Bulk upload
            </div>
            <div className={`${styles.myGift_text}`}>
              View and manage Bulk upload
            </div>
          </div>

          <Row>
            {/* <Button
              className={`${styles.export_button}`}
              onClick={() => setAllExortModalOpen(true)}
            >
              Export
            </Button> */}
            <Button
              className={`${styles.declareGift_button}`}
              icon={<PlusOutlined />}
              onClick={() => history.push('/create-bulk-upload-flow')}
            >
              Add Bulk upload
            </Button>
            <Button
              style={{ marginLeft: '20px' }}
              className={`${styles.declareGift_button}`}
              icon={<ArrowLeftOutlined />}
              onClick={() => history.push('/admin')}
            >
              Back
            </Button>
          </Row>
        </Row>
        <div className={`${styles.tabs_container}`}>
          <Row>
            {/* className={`${styles.row_container}`} */}
            <Col span={16}>
              <Radio.Group
                value={radiofilter}
                size="small"
                className={`${styles.button_import_style}`}
              >
                {filters.map((item, index) => {
                  return (
                    <Radio.Button
                      value={item.value}
                      key={index}
                      //className={`${styles.RadioButton_import_style}`}
                      onChange={() => {
                        window.localStorage.setItem(
                          'set_Radiofilter',
                          JSON?.stringify(item.value)
                        );
                        setRadiofilter(item.value);
                        setTriggerFilter(true);
                      }}
                    >
                      {item.name}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Col>
            <Col span={8}>
              <SearchBar
                onChange={(e) => {
                  setSearchRequest(e.target.value);
                  setTriggerFilter(true);
                }}
                className={` ${styles.searchbar}`}
                inputProps={{
                  placeholder: 'Search by fiscal year'
                }}
              />
            </Col>
          </Row>
        </div>
        <Card className={`${styles.cardStyles}`}>
          <div className={`${styles.table_container}`}>
            <CustomTable
              columns={columns}
              dataSource={bulkGiftConfigsList || []}
              locale={locale}
              loading={adminBulkGiftConfigsLoading}
              pagination={{
                current: page,
                pageSize: pageSize,
                showSizeChanger: true,
                size: 'small',
                total: pagination?.total_records || pagination?.total || 0,
                onChange: (page, pageSize) => {
                  setPage(page);
                  setPageSize(pageSize);
                }
              }}
            />
          </div>
        </Card>
        {isAllExortModalOpen ? (
          <AllExportReports
            isAllExortModalOpen={isAllExortModalOpen}
            setAllExortModalOpen={setAllExortModalOpen}
            apiName={'project_sites_master'}
          />
        ) : (
          ''
        )}
      </div>
    </>
  );
}
export default BulkUploadFlowPage;
